const HolidaysItem = ({ holiday }) => {
    const monthShort = holiday.month.slice(0, 3).toUpperCase();
    
    return (
        <div className="d-flex align-items-center mb-3" style={{ gap: "16px" }}>
            
            <div 
                style={{
                    width: "46px", 
                    height: "46px",
                    borderRadius: "50%",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                    fontWeight: "700",
                    boxShadow: "var(--shadow-sm)",
                    border: "1px solid var(--gray-200)",
                    flexShrink: 0
                }}
            >
                <div 
                    style={{
                        flex: 1,
                        backgroundColor: "var(--danger-red)",
                        color: "var(--white)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "0.7rem", 
                        letterSpacing: "1px",
                        paddingTop: "2px"
                    }}
                >
                    {monthShort}
                </div>

                <div 
                    style={{
                        flex: 1,
                        backgroundColor: "var(--bg-surface)",
                        color: "var(--text-primary)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "1.1rem", 
                        lineHeight: "1"
                    }}
                >
                    {holiday.day}
                </div>
            </div>

            <div 
                className="txt-main" 
                style={{ 
                    fontSize: "0.95rem",
                    fontWeight: "600" 
                }}
            >
                {holiday.holiday_name}
            </div>
            
        </div>
    );
};

export default HolidaysItem;